/*!

=========================================================
* Paper Dashboard PRO React - v1.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/paper-dashboard-pro-react
* Copyright 2019 Creative Tim (https://www.creative-tim.com)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from 'react';
// javascript plugin used to create scrollbars on windows
import { Route, Routes, Outlet } from 'react-router-dom';

const OpenArea = props => {
  const mainPanel = React.createRef();

  const [menu, setMenu] = React.useState(true);

  return (
    <>
      <Outlet />
    </>
  );
};

export default OpenArea;
